import {FbFormObject} from '../class/fb_form_object';

export class ScbEventRefineryFeeBv2 extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'user_id', label: 'SC Username', visible: true, noclick: false, disable_ripple: true},
            {id: 'refinery_fee', label: 'refinery fee', visible: true, noclick: false, disable_ripple: true}
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'Refinery fee',
                class: 'card card-1 padding single-column',
                field_class: '',
                fields: [
                    {
                        type: 'autocomplete',
                        name: 'user_id',
                        options: this.select_boxes['sc_user_select'],
                        disabled: false
                    },
                    {
                        type: 'number',
                        name: 'refinery_fee',
                        disabled: false
                    }
                ]
            }
        ];
        super.setEditFields();
    }

    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.stores['event_refinery_fee'] = this.storeService.createNoneGlobalStore('event-refinery-fee',
                'games/starcitizen/events/' + String(ext_obj.event_id) + '/commodities/refinery_fee',
                'id');
            this.stores['event_member'] = this.storeService.createNoneGlobalStore('event-member',
                'games/starcitizen/events/' + String(ext_obj.event_id) + '/member',
                'user_id');
            this.main_store = this.stores['event_refinery_fee'];

            const tagFilter = [];
            tagFilter.push('first=0');
            tagFilter.push('no_limit=1');

            const stores = [];
            if (!this.stores['event_refinery_fee'].isLoaded()) {
                stores.push(this.stores['event_refinery_fee'].loadStore(this.filter));
            }
            if (!this.stores['event_member'].isLoaded()) {
                stores.push(this.stores['event_member'].loadStore('?' + tagFilter.join('&')));
            }

            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        return {
            data: {
                event_id: this.custom_obj.event_id,
                refinery_fee: 0
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        this.parseScUserSelectbox();
        // call super
        super.setSelectboxes();
    }

    public parseScUserSelectbox() {
        const options = [];
        const records = this.stores['event_member'].getRecords();
        for (let i = 0; i < records.length; i++) {
            options.push({
                value: String(records[i].data.user_id),
                name: records[i].data.sc_username
            });
        }
        this.select_boxes['sc_user_select'] = options;
        return this.select_boxes['sc_user_select'];
    }
}
